export default "__VITE_ASSET__4eeb18e6__"